<template>
  <div v-if="detail != ''" class="container">
    <ul>
      <li>
        <label>项目名称：</label>
        <p>{{ detail.project_name }}</p>
      </li>
      <li>
        <label>网点设备：</label>
        <p>{{ detail.device_name }}</p>
      </li>
      <li>
        <label>网点地址：</label>
        <p>{{ detail.address }}</p>
      </li>
      <li>
        <label>员工：</label>
        <p>{{ detail.user_name }}</p>
      </li>
      <li>
        <label>盘点单创建时间：</label>
        <p>{{ detail.create_time }}</p>
      </li>
      <li>
        <label>盘点单修改时间：</label>
        <p>{{ detail.create_time }}</p>
      </li>
      <li>
        <label>状态：</label>
        <p v-show="detail.status == 1">待审核</p>
        <p v-show="detail.status == 2">已通过</p>
        <p v-show="detail.status == 3">已驳回</p>
      </li>
      <li v-show="detail.status == 3">
        <label>驳回原因：</label>
        <p>{{ detail.reason }}</p>
      </li>
      <li v-show="detail.status == 2 || detail.status == 3">
        <label>审核人：</label>
        <p>{{ detail.check_user_name }}</p>
      </li>
      <li v-show="detail.status == 2 || detail.status == 3">
        <label>审核时间：</label>
        <p>{{ detail.check_time }}</p>
      </li>
    </ul>
    <table>
      <thead>
        <th>商品名称</th>
        <th>商品图</th>
        <th>盘点前库存</th>
        <th>盘点后库存</th>
        <th>差异</th>
      </thead>
      <tbody>
        <tr v-for="(item, index) in detail.material_list" :key="index">
          <td>{{ item.brand_name }}</td>
          <td>
            <img :src="item.imageUrl.url_thumb" alt="" />
          </td>
          <td>{{ item.real_inventory_before }}</td>
          <td>{{ item.real_inventory }}</td>
          <td>
            {{
              Number(item.real_inventory) - Number(item.real_inventory_before)
            }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="operation" v-show="detail.status == 1">
      <a-button type="primary" @click="auditPagePass">
        盘点通过
      </a-button>
      <a-button type="danger" @click="auditPageReject">
        盘点驳回
      </a-button>
    </div>
    <!-- 驳回 -->
    <section class="dialogsBox" v-show="rejectIsShow">
      <div>
        <h3>驳回</h3>
        <ul>
          <li>
            <label><i>*</i>驳回原因：</label>
            <a-textarea
              v-model="reason"
              placeholder="请输入驳回原因"
              style="width: 300px"
            />
          </li>
        </ul>
        <div>
          <a-button @click="rejectIsShow = false">取消</a-button>
          <a-button type="primary" @click="rejectSure">确认</a-button>
        </div>
      </div>
    </section>
    <!-- 驳回 end -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      detail: "",
      rejectIsShow: false,
      reason: ""
    };
  },
  props: {
    detailVal: {}
  },
  watch: {
    detailVal() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.detailVal != undefined) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.detail = this.detailVal;
      // console.log(this.detail);
    },
    auditPagePass() {
      let _this = this;
      this.$confirm({
        title: "审核盘点",
        content: "一旦确定，库存进行自动校正，是否确认操作!",
        cancelText: "取消",
        okText: "确认",
        onOk() {
          _this.orderPassOperation();
        },
        onCancel() {}
      });
    },
    orderPassOperation() {
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Device_check/adopt";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          id: this.detail.id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("审核成功");
          } else {
            this.$message.info(res.data.message);
          }
          this.$emit("hideIsDetail", true);
        })
        .catch(err => {});
    },
    auditPageReject() {
      this.rejectIsShow = true;
    },
    rejectSure() {
      this.rejectIsShow = false;

      if (this.reason != "" && this.reason != null) {
        let url =
          this.httpsBasic.url +
          this.httpsBasic.equipment +
          "Device_check/reject";
        axios
          .post(url, {
            token: window.localStorage.getItem("xnwfPcToken"),
            id: this.detail.id,
            reason: this.reason
          })
          .then(res => {
            if (res.data.code == 200) {
              this.$message.success("已驳回");
              this.$emit("hideIsDetail", true);
            } else {
              this.$message.info(res.data.message);
            }
          })
          .catch(err => {});
      } else {
        this.$message.info("请填写驳回原因");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 2%;
  position: relative;
  ul {
    li {
      margin-bottom: 10px;
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
  table {
    td,
    th {
      border: 1px solid #ccc;
      padding: 4px 6px;
    }
    tr {
      img {
        height: 30px;
        width: 30px;
      }
    }
  }
  .operation {
    position: absolute;
    right: 30px;
    top: 20px;
    display: flex;
    flex-direction: column;
    button {
      margin-bottom: 16px;
    }
  }
}
</style>
